import {
  isExplorativeDxOrgKind,
  organizationKindList,
} from "@/domain/Organization";
import { createContext, useContext } from "react";

// LDS は組織種別ごとに接続先サービスが分かれている。
// - "default": 従来の api.* (非探索型DX組織)
// - "exp": lds-exp.api.* (探索型DX組織)
export type LdsEndpointVariant = "default" | "exp";

export const orgKindToLdsEndpointVariant = (
  orgKind: (typeof organizationKindList)[number] | null | undefined
): LdsEndpointVariant => (isExplorativeDxOrgKind(orgKind) ? "exp" : "default");

// 接続先 variant はレンダー副作用のグローバルではなく、コミット済みツリーに紐づく
// context で配る。並行レンダー/Suspense で破棄されたレンダーの値が、コミット済みの
// Host に漏れて誤った接続先(通常組織→lds-exp 等)へ繋ぐのを防ぐ。
export const LdsEndpointVariantContext =
  createContext<LdsEndpointVariant>("default");

export const useLdsEndpointVariant = () =>
  useContext(LdsEndpointVariantContext);
